import { render } from "./PhoneView.vue?vue&type=template&id=c44d1568&scoped=true"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"

import "./PhoneView.vue?vue&type=style&index=0&id=c44d1568&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44d1568"]])

export default __exports__